<template>
    <modal v-model="show" max-width="600" :has-padding="false">
        <connections-mac-register-modal
            :dataActivatorText="$t('message.overview.message.registerIp')"
            @changed="load"
        ></connections-mac-register-modal>

        <div class="wrapper">
            <div class="header">
                <div class="flex">
                    <button
                        class="btn btn-primary btn-extra-round"
                        slot="activator"
                        @click="create()"
                    >
                        {{ $t("message.generics.message.register") }}
                    </button>
                    <i
                        class="mdi mdi-file-upload-outline mr-4"
                        v-tooltip.auto="'Importar lista'"
                        @click="openUploadModal"
                    ></i>
                </div>

                <div class="search-wrapper">
                    <app-search @enter="search" />
                </div>
            </div>

            <v-data-table
                :headers="headers"
                :items="list"
                :total-items="30"
                :loading="loading"
                id="macTable"
                :hide-actions="true"
                :must-sort="true"
                :no-data-text="$t('message.generics.message.noData')"
                :no-results-text="$t('message.generics.message.noData')"
                sort-icon="mdi-chevron-down"
            >
                <v-progress-linear
                    slot="progress"
                    :color="providerColor"
                    indeterminate
                />

                <template slot="items" slot-scope="props">
                    <connections-mac-management-modal-table-item
                        :data-item="props.item"
                        @deleted="load"
                    ></connections-mac-management-modal-table-item>
                </template>
            </v-data-table>

            <connections-mac-management-upload-modal
                :showing.sync="showingUploadModal"
                @added="load"
            ></connections-mac-management-upload-modal>
        </div>
    </modal>
</template>

<script>
import ConnectionsMacRegisterModal from "./components/ConnectionsMacRegisterModal.vue";
import ConnectionsMacManagementUploadModal from "./components/ConnectionsMacManagementUploadModal.vue";
import ConnectionsMacManagementModalTableItem from "./components/ConnectionsMacManagementModalTableItem.vue";
import EventBus from "@packages/event-bus";
import AppSearch from "@components/Search";
import Modal from "@/components/generic/Modal";
import provider from "@mixins/provider";

export default {
    components: {
        AppSearch,
        Modal,
        ConnectionsMacRegisterModal,
        ConnectionsMacManagementUploadModal,
        ConnectionsMacManagementModalTableItem,
    },

    data() {
        return {
            show: false,
            list: [],
            loading: false,
            showingUploadModal: false,
            // infiniteId: +new Date(),
        };
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("message.connections.message.mac"),
                    value: "mac",
                },
                { text: "Ação", value: "acao" },
            ];
        },
    },
    mixins: [provider],
    methods: {
        async load() {
            this.loading = true;
            this.list = await this.$api.macAddresses.list();
            this.loading = false;
        },
        async search(search) {
            if (!search) {
                this.list = await this.$api.macAddresses.list();
            } else {
                this.list = await this.$api.macAddresses.listByMac(search);
            }
        },
        create() {
            EventBus.$emit("REGISTER_MAC");
        },
        editMacs() {
            this.load();
            this.show = true;
        },
        openUploadModal() {
            this.showingUploadModal = true;
        },
    },
    mounted() {
        EventBus.$on("EDIT_MACS", this.editMacs);
        EventBus.$on("LOAD_MACS", this.load);
    },
    beforeDestroy() {
        EventBus.$off("EDIT_MACS", this.editMacs);
        EventBus.$off("LOAD_MACS", this.load);
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    padding: 20px;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        .flex {
            display: flex;
            align-items: center;
            gap: 15px;

            .mdi {
                font-size: 28px;
                cursor: pointer;
                vertical-align: middle;
            }
        }
    }

    #macTable {
        max-height: 500px;
        overflow-y: auto !important;
    }
}
</style>
